import MetaHeader from '../components/common/MetaHeader';
import ALink from '../components/common/ALink';

export default function ShippingWarranty() {
  return (
    <>
    <MetaHeader title={'Shipping & Warranty'}/>
    <main className="main">
      <nav aria-label="breadcrumb" className="breadcrumb-nav mb-0">
        <div className="container">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <ALink href="/">Home</ALink>
            </li>
            <li className="breadcrumb-item">
              <ALink href="#">Pages</ALink>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Shipping & Warranty Concerns Explained
            </li>
          </ol>
        </div>
      </nav>

      <div className="container">
        <div className="subpage">
          <h1 className="subpage__title">Shipping</h1>
          <div className="subpage__section">
            <p className="subpage__paragraph">
              Customers assume responsibility for all item(s) on their lease as soon as the item is shipped, including
              for returns. BuyOnTrust is not responsible for item(s) not received, lost, stolen, damaged, or any other
              issues.
            </p>
          </div>
          <div className="subpage__section">
            <p className="subpage__paragraph bolder">
              Customers are required to email:
              <a
                  href="mailto:info@buyontrust.com"
                  style={{
                    marginLeft: '4px',
                    color: '#4f4f4f',
                    fontWeight: '600'
                  }}>
                info@buyontrust.com
              </a>
            </p>
            <p className="subpage__paragraph bolder">
              Subject line:
              <a
                  style={{
                    marginLeft: '4px',
                    color: '#4f4f4f',
                    fontWeight: '600'
                  }}>
                Shipped Item Issue
              </a>
            </p>
            <p className="subpage__paragraph bolder">
              Provide a full explanation of what you believe happened.
            </p>
          </div>

          <p className="subpage__paragraph">
            Customers may be required to initiate an investigation with their local police department, the courier,
            and/or any other applicable policing agency or entity to assist in the recovery of stolen items and the
            apprehension of the criminals responsible. This is to protect BuyOnTrust and all others against injury.
          </p>
          <p className="subpage__paragraph">
            Customers are financially responsible for all items during pending investigations. We appreciate your
            patience, business, and the opportunity to help with these matters, though we can offer no guarantees. </p>
          <p className="subpage__paragraph">
            BuyOnTrust appreciates your business, patience, and cooperation as we work to provide our customers with
            top-quality customer service. Customers are financially responsible for all items during pending
            investigations. BuyOnTrust reserves the right to issue, and/or not issue, refunds or lease adjustments at
            its discretion. Your financial obligations are also to your lease provider. BuyOnTrust yields to the lease
            provider for many final decisions. Customers are encouraged to speak with their lease provider regarding any
            financial matters, especially when their item is no longer returnable to the retail store. Restocking and/or
            rental fees may be applicable.
          </p>
        </div>
        <div className="subpage">
          <h1 className="subpage__title">Warranty Concerns Explained</h1>
          <p className="subpage__paragraph">
            Many items come with a manufacturer guarantee. Additionally, customers may be able to purchase a third-party insurance product to help protect their belongings. These options are separate and outside of the BuyOnTrust program. BuyOnTrust does not offer any warranty or insurance on any products. Customers are encouraged, but not required, to consider purchasing protection for their item(s). This can be done by contacting a local insurance agent.
          </p>
          <p className="subpage__paragraph">
            BuyOnTrust appreciates your business, patience, and cooperation as we work to provide our customers with top-quality customer service. Customers are financially responsible for all items during pending investigations. BuyOnTrust reserves the right to issue, and/or not issue, refunds or lease adjustments at its discretion. Your financial obligations are also to your lease provider. BuyOnTrust yields to the lease provider for many final decisions. Customers are encouraged to speak with their lease provider regarding any financial matters, especially when their item is no longer returnable to the retail store. Restocking and/or rental fees may be applicable.
          </p>
        </div>
      </div>
    </main>
    </>
  );
}
